import { render, staticRenderFns } from "./IconNavigationNotifications.vue?vue&type=template&id=16f64ab5"
import script from "./IconNavigationNotifications.vue?vue&type=script&lang=js"
export * from "./IconNavigationNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports